<script setup>
import { computed } from 'vue';

const emit = defineEmits(['click']);

const props = defineProps({
  currentIndex: {
    required: true,
    type: Number,
  },
  index: {
    required: true,
    type: Number,
  },
  setSize: {
    required: true,
    type: Number,
  },
  startingIndex: {
    default: 0,
    required: false,
    type: Number,
  },
  classPrefix: {
    type: String,
    required: false,
  },
});

const selected = computed(() => props.currentIndex === props.startingIndex + props.index);
const posInSet = computed(() => props.startingIndex + props.index + 1);
const id = computed(() => `option__${props.index}`);

function clickHandler() {
  emit('click');
}
</script>

<template>
  <li
    @click="clickHandler"
    :aria-posinset="posInSet"
    :aria-selected="selected"
    :aria-setsize="props.setSize"
    :id="id"
    class="c-base-listbox__option"
    :class="`${classPrefix}option`"
    role="option"
  >
    <slot />
  </li>
</template>
